import { render } from "./GestionComponent.vue?vue&type=template&id=6faeffd8"
import script from "./GestionComponent.vue?vue&type=script&lang=js"
export * from "./GestionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__